import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, exhaustMap, filter, map, withLatestFrom } from "rxjs/operators";

import { HrrService } from "../../../services/api/hrr.service";
import { HrrActions } from "../../actions/hrr.actions";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { HrrSelectors } from "../../selectors/hrr.selectors";

export const HRR_MAX_AGE_MS = 15 * 60 * 1000;

@Injectable()
export class HrrEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(HrrActions.list.get),
			withLatestFrom(this.store.select(HrrSelectors.loaded), this.store.select(HrrSelectors.fetchedAt)),
			filter(([, loaded, fetchedAt]) => !loaded || fetchedAt == null || Date.now() - fetchedAt >= HRR_MAX_AGE_MS),
			map(() => HrrActions.list.getApi())
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(HrrActions.list.getApi),
			exhaustMap(() =>
				this.hrrService.fetchHrrList().pipe(
					map((list) => HrrActions.list.getSuccess({ list, fetchedAt: Date.now() })),
					catchError((error) => of(HrrActions.list.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private hrrService: HrrService
	) {}
}
